import { useLayoutEffect, useRef, useState } from 'react';

export const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const node = headerRef.current;
    const { height } = node?.getBoundingClientRect() || { height: 0 };

    setHeaderHeight(height);
  }, []);

  return { headerHeight, headerRef };
};
